export interface ICookieService {
    setCookie(cookieName:string, cookieValue:string, minutes:number) : void;
    getCookie(cookieName:string): string;
}

export class CookieService implements ICookieService{
    
    static $inject = ["$document"];

    public constructor(
        private $document:ng.IDocumentService
    ) {

    }      
    //wanted to use the following but it was being a pain to install it and wouldn't go into the global folder
    //the other modules, keeps complaining about it being external, etc.....
    //https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/angular-cookies
    //https://www.npmjs.com/package/@types/angular-cookies

    //pulled these straight off of w3schools and modified for typescript/angularjs, and a bit more
    public setCookie(cookieName:string, cookieValue:string, minutes:number) : void {
        const expires = new Date();
        expires.setTime(expires.getTime() + (minutes*60*1000));        
        this.$document[0].cookie = `${cookieName}=${cookieValue};expires=${expires.toUTCString()};path=/`;
    }
    
    public getCookie(cookieName:string):string {
        const name = cookieName + "=";
        const cookies = this.$document[0].cookie.split(';');
        for(var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    }
}
